var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "pa-4",
    attrs: {
      "elevation": "1"
    }
  }, [_c('v-row', {
    staticClass: "justify-space-between align-center mb-4"
  }, [_c('span', {
    staticClass: "font-weight-medium"
  }, [_vm._v("Status de Formações")]), _c('v-btn', {
    attrs: {
      "outlined": "",
      "small": "",
      "color": "black"
    },
    on: {
      "click": _vm.onVisualizarListagem
    }
  }, [_vm._v("Visualizar Listagem")])], 1), _c('v-row', {
    staticClass: "mb-1",
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l(_vm.statusList, function (status) {
    return _c('div', {
      key: status.label,
      staticClass: "text-center caption",
      staticStyle: {
        "flex": "1",
        "padding": "1.5rem 0"
      }
    }, [_vm._v(" " + _vm._s(status.label) + " ")]);
  }), 0), _c('v-row', {
    staticClass: "rounded overflow-hidden status-bar mb-2",
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l(_vm.statusList, function (status) {
    return _c('div', {
      key: status.label,
      staticClass: "status-segment white--text d-flex align-center justify-center",
      style: {
        backgroundColor: status.color,
        flex: 1
      }
    }, [_vm._v(" " + _vm._s(status.value) + " ")]);
  }), 0), _c('v-alert', {
    staticClass: "grey lighten-3 caption mt-2 pa-2 d-flex align-center justify-center",
    attrs: {
      "type": "info",
      "border": "top",
      "dense": "",
      "text": ""
    }
  }, [_vm._v(" Dados refletem a situação até o dia " + _vm._s(_vm.dataHoraInfo) + " ")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }